import { isNil } from 'ramda';
import { addFee } from '~admin/view/components/create-event/helper/event-profile-request/event-fee-details/add-fee.helper';
import * as taxesCAD from '~admin/view/components/create-event/helper/event-profile-request/event-fee-details/data/taxes.data.cad.json';
import * as taxesUSD from '~admin/view/components/create-event/helper/event-profile-request/event-fee-details/data/taxes.data.usd.json';
import { FeeRequest } from '~client/model/admin/fee-request';
import { TaxType } from '~client/model/admin/tax-type';
import { Currency } from '~client/model/currency';
import {
  ApplicationLevel,
  BreakdownDisplayOption,
  Reason,
  ResponsibilityType,
  ValueType,
} from '~client/model/fee-breakdown-item';

interface Tax {
  feeName: string;
  feeNameFrench: string;
  feeNameLong: string;
  feeNameLongFrench: string;
  percentage: number;
  subReason?: string;
}

const taxList = (currency: Currency): Tax[] => {
  switch (currency) {
    case Currency.CAD:
      return taxesCAD.list;
    case Currency.USD:
      return taxesUSD.list;
    default:
      throw Error(`No taxes defined for ${currency}.`);
  }
};

export const buildTaxList = (
  feeList: FeeRequest[],
  hasResale: boolean,
  taxType: TaxType,
  currency: Currency,
): void => {
  if (!isNil(taxType) && taxType !== TaxType.NONE) {
    const included = taxType === TaxType.INCLUDED;

    taxList(currency).forEach((tax: Tax) => {
      const { feeName, feeNameLong, feeNameFrench, feeNameLongFrench, percentage } = tax;

      addFee(
        feeList,
        percentage,
        hasResale ? percentage : 0,
        included,
        {
          applicationLevel: ApplicationLevel.TRANSACTION,
          breakdownDisplayOption: included
            ? BreakdownDisplayOption.EMAIL
            : BreakdownDisplayOption.ALL,
          feeName,
          responsibilityType: ResponsibilityType.BUYER,
          valueType: ValueType.PERCENTAGE,
          applyOrder: 3,
          reason: Reason.TAX,
          subReason: tax.subReason,
          translations: [{ locale: 'fr', name: feeNameFrench, nameLong: feeNameLongFrench }],
        },
        feeNameLong,
      );

      if (hasResale && included) {
        addFee(
          feeList,
          percentage,
          percentage,
          true,
          {
            applicationLevel: ApplicationLevel.PREVIOUS_FEE,
            breakdownDisplayOption: BreakdownDisplayOption.EMAIL,
            feeName,
            responsibilityType: ResponsibilityType.SELLER,
            valueType: ValueType.PERCENTAGE,
            applyOrder: 3,
            reason: Reason.TAX,
            subReason: tax.subReason,
            translations: [{ locale: 'fr', name: feeNameFrench, nameLong: feeNameLongFrench }],
          },
          feeNameLong,
        );
      }
    });
  }
};



// WEBPACK FOOTER //
// ./view/components/create-event/helper/event-profile-request/event-fee-details/build-tax-list.helper.ts